import { render, staticRenderFns } from "./ListarInstituciones.vue?vue&type=template&id=48678429&"
import script from "./ListarInstituciones.vue?vue&type=script&lang=js&"
export * from "./ListarInstituciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports